import { OutdoorType } from 'core/creative/Creative';
import { BasicOutdoorFormModel, OutdoorFormProps } from './OutdoorFormModel';
import { OutdoorForm } from './OutdoorForm';
import i18n from 'i18n';

export class SandboxOutdoorFormModel extends BasicOutdoorFormModel<SandboxOutdoorFormModel> {
  override get channelName() {
    return 'Sandbox';
  }

  override get useMediaDuration() {
    return true;
  }

  // 研發測試用：允許編輯既有素材時調整圖片播放時長（RKB-2385 / ECOPD-5342）
  override get allowEditImageDuration() {
    return true;
  }

  override async getCreativeSizes() {
    return undefined;
  }

  override getOutdoorTypeOptions() {
    return [
      {
        label: i18n.t('outdoorForm.labels.outdoorType1'),
        value: OutdoorType.VIDEO
      },
      {
        label: i18n.t('outdoorForm.labels.outdoorType2'),
        value: OutdoorType.IMAGE_AUDIO
      }
    ];
  }

  override getFormContent(): (
    props: OutdoorFormProps<SandboxOutdoorFormModel>
  ) => JSX.Element {
    return OutdoorForm<SandboxOutdoorFormModel>;
  }

  override getDefaultDuration = (_1: OutdoorType, oldDuration: number) => {
    const notInDurationOption = oldDuration !== 0 && oldDuration !== 30;
    if (notInDurationOption) {
      return 30;
    }

    return oldDuration;
  };

  override getVideoHints() {
    return [i18n.t('creativeSetupFlow.labels.videoTypeHint')];
  }

  override validateVideo(_1: number, _2: number, fileData: MediaFieldData) {
    const validTypes = ['video/mp4'];
    if (this.isFileFieldEmpty(fileData)) {
      return i18n.t('formValidate.labels.emptyError');
    }

    if (!this.hasFile(fileData)) {
      return;
    }

    const file = fileData.file;
    if (validTypes.indexOf(file.type) === -1) {
      return i18n.t('creativeSetupFlow.labels.videoTypeHint');
    }
  }
}
